import axios from "axios";
import {baseAddress} from "../../../tools/baseAddress";

let addressGenerateImage = baseAddress + "api/generate_image";
let addressExportPDF = baseAddress + "api/exportPDF";

export const generate_img = (dataInput) => {
    const token = localStorage.getItem("token");
    
    if (!token) {
        window.location.href = '/login';
        return Promise.reject("No token");
    }
    
    return axios
        .post(addressGenerateImage, {
            dataInput: dataInput,
            token: token
        })
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error('MagneticAction - error:', err);
            if (err.response && err.response.status === 401) {
                localStorage.removeItem('token');
                window.location.href = '/login';
            }
            throw err;
        });
};

export const exportPDF = (parameters) => {
    const token = localStorage.getItem("token");
    
    if (!token) {
        window.location.href = '/login';
        return Promise.reject("No token");
    }
    
    return axios
        .post(addressExportPDF, {
            param: parameters,
            token: token
        })
        .then(response => {
            return response;
        })
        .catch(err => {
            console.error('MagneticAction - exportPDF error:', err);
            if (err.response && err.response.status === 401) {
                localStorage.removeItem('token');
                window.location.href = '/login';
            }
            throw err;
        });
};